import React from 'react'
import { View, StyleSheet, Text } from '@react-pdf/renderer'
import { Solicitacao } from '@modules/viagem/interfaces/Viagem'
import { ListaSolicitacao } from '@modules/solicitacao/interfaces/Solicitacao'
import { formatCurrency, formatToBrNumber } from '@utils/format'

const Column: React.FC <{width: string, text: string | number}> = ({ width, text }) => {

    const styles = StyleSheet.create({
        column: {
            width,
            paddingHorizontal: 4
        },
        text: {
            fontSize: 6,
        }
    })

    return(

        <View style = {styles.column}>
            <Text style = {styles.text}>{text}</Text>
        </View>

    )

}

const PdfRomaneioProtocoloItem: React.FC <ListaSolicitacao> = data => {

    const styles = StyleSheet.create({
        row: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            paddingVertical: 4,
            borderBottom: "1px solid black",
        },
    })

    return(

        <View style = {styles.row}>
            <Column
                width = "10%"
                text = {data.nrNf}
            />
            <Column
                width = "23%"
                text = {data.nmRemetente}
            />
            <Column
                width = "23%"
                text = {data.nmDestinatario}
            />
            <Column
                width = "10%"
                text = {data.nrCto}
            />
            <Column
                width = "10%"
                text = {`${formatToBrNumber(Number(data.pesoMercadoria) / 1000)} t`}
            />
            <Column
                width = "12%"
                text = {formatCurrency(data.valorMercadoria)}
            />
            <Column
                width = "12%"
                text = {formatCurrency(data.valorFreteCobrado)}
            />
        </View>

    )

}

export default PdfRomaneioProtocoloItem